import { Checkbox, Flex, Text } from '@chakra-ui/react';
import { SimpleContact } from '@texas/api/endpoints/contactsApi';

interface AddVariantSupplierContactProps {
  contact: SimpleContact;
  selected: boolean;
  onChange: () => void;
}

export function AddVariantSupplierContact({
  contact,
  selected,
  onChange,
}: AddVariantSupplierContactProps) {
  return (
    <Flex
      as="label"
      align="center"
      gap={3}
      p={4}
      cursor="pointer"
      border="1px solid"
      borderColor="entityDirectory.border"
    >
      <Checkbox isChecked={selected} onChange={onChange} borderRadius={0} />
      <Flex direction="column" minW={0}>
        <Text fontWeight="semibold" noOfLines={1}>
          {contact.name}
        </Text>
        <Text color="entityDirectory.mutedText" fontSize="sm" noOfLines={1}>
          {contact.email}
        </Text>
      </Flex>
    </Flex>
  );
}
